import { cx } from 'linaria';
import * as React from 'react';

import { flattenReactChildren } from '../utils/flatten-react-children';

import { BreadcrumbsContext } from './breadcrumbs.context';
import * as styles from './breadcrumbs.styles';

export type BreadcrumbsProps = React.AllHTMLAttributes<HTMLElement>;

type BreadcrumbsComponent = React.ForwardRefExoticComponent<
    React.PropsWithChildren<BreadcrumbsProps> & React.RefAttributes<HTMLElement>
>;

export const Breadcrumbs: BreadcrumbsComponent = React.forwardRef<HTMLElement, BreadcrumbsProps>((props, ref) => {
    const { children, className } = props;
    const flatChildren = flattenReactChildren(children);

    const containerRef = React.useRef<HTMLOListElement>();

    const lastIndex = flatChildren.length - 1;
    const transformChildren = (flatChildren as Array<React.ReactElement>).reduce((accumulator, current, index) => {
        accumulator.push(
            <BreadcrumbsContext.Provider key={index} value={{ isCurrent: index === lastIndex }}>
                {current}
            </BreadcrumbsContext.Provider>,
        );

        return accumulator;
    }, []);

    return (
        <nav ref={ref} className={cx(styles.root, className)} aria-label="Breadcrumb">
            <ol ref={containerRef} className={cx(styles.orderedList)}>
                {transformChildren}
            </ol>
        </nav>
    );
});

Breadcrumbs.displayName = 'Breadcrumbs';
